import React, { useState, useRef, useEffect } from 'react';
import './TableActions.css';

/**
 * M3 Table Actions — icon buttons with M3 ripple and hover states.
 *
 * @param {{ icon: string; label: string; onClick?: () => void; danger?: boolean; to?: string }[]} items
 * @param {string} [className]
 */
export default function TableActions({ items, className }) {
  return (
    <div className={`table-actions ${className || ''}`}>
      {items.map((item, i) => {
        if (item.to) {
          const { to, icon, label, danger } = item;
          return (
            <a
              key={i}
              href={to}
              className={`table-action-link ${danger ? 'table-action-link-danger' : ''}`}
              title={label}
            >
              <span className="material-symbols-rounded">{icon}</span>
            </a>
          );
        }

        const { icon, label, onClick, danger } = item;
        return (
          <button
            key={i}
            className={`table-action-btn ${danger ? 'table-action-btn-danger' : ''}`}
            onClick={onClick}
            title={label}
          >
            <span className="material-symbols-rounded">{icon}</span>
          </button>
        );
      })}
    </div>
  );
}
